import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Applications = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      title: 'Applications in Packaging and Printing Industry',
      items: [
        'Hot melt adhesives for Corrugated carton closing',
        'Hot melt adhesives for Tray Forming',
        'Hot melt adhesives for Book Binding',
        'Hot melt adhesives for Duplex box sealing & side pasting',
        'Hot melt adhesives for Pick up Al Foil.',
        'Hot melt adhesives for Aluminum Tape lamination',
      ],
    },
    {
      title: 'Applications in Furniture and Wood working Industry',
      items: ['Edge lipping', 'Edge banding', 'Finger Joints'],
    },
    {
      title: 'Applications in Water, Food and Beverage Industry',
      items: [
        'Pressure Sensitive Hot melt adhesives for bottle labeling',
        'Straw Fixing',
        'Wrappers',
      ],
    },
    {
      title: 'Applications in Hygienic Applications',
      items: [
        'Construction – Hot melt Adhesives for Diapers',
        'Elastic – Hot melt Adhesives for Diapers',
        'Core – Hot melt Adhesive used in Hygiene industry',
        'Positioning – Hot melt Adhesive for Sanitary Napkin',
      ],
    },
    {
      title: 'Other Applications',
      items: [
        'Hot melt adhesive for Air Filters and Filter Assembly',
        'Hot melt adhesives for mattress industry.',
        'Courier Bag',
        'Jumbo Bag',
        'PP Bag',
        'Paper Bag',
      ],
    },
  ];

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  return (
    <div className="container my-5" style={{ color: '#f8f9fa', backgroundColor: '#000' }}>
      <h2
        className="text-center mb-4"
        style={{
          fontFamily: 'Poppins',
          fontWeight: '600',
          color: 'lightskyblue', // Green title for dark theme
        }}
      >
        Hot Melt Adhesive Applications
      </h2>
      <div className="accordion" id="applicationsAccordion">
        {sections.map((section, index) => (
          <div className="accordion-item mb-3" key={index}>
            <h2
              className="accordion-header"
              id={`heading-${index}`}
              onClick={() => toggleSection(index)}
              style={{ cursor: 'pointer', backgroundColor: '#000' }} // Changed to full black background
            >
              <button
                className={`accordion-button ${
                  activeSection === index ? '' : 'collapsed'
                }`}
                type="button"
                style={{
                  backgroundColor: '#000',
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '16px',
                }}
              >
                {section.title}
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className={`accordion-collapse collapse ${
                activeSection === index ? 'show' : ''
              }`}
              data-bs-parent="#applicationsAccordion"
            >
              <div
                className="accordion-body"
                style={{
                  backgroundColor: '#000',
                  color: '#ddd',
                  border: '1px solid #444',
                }}
              >
                <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
                  {section.items.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '10px',
                        fontSize: '15px',
                      }}
                    >
                      <span
                        style={{
                          color: '#00ff00', // Green checkmark
                          fontWeight: 'bold',
                          marginRight: '10px',
                          fontSize: '20px',
                        }}
                      >
                        ✓
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Applications;
